<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="type" slot-scope="params">
        <span v-if="params.params.index == 1">客户</span>
        <span v-if="params.params.index == 2">承运人</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "CustomerLlog",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'clog',
      formInline: {},
      formCtrl: [
        {
          label: "公司名称",
          keyName: "cusname",
          placeholder: "请填写公司名称",
          type: "text",
        },
        {
          label: "操作时间",
          keyName: "updateTime",
          placeholder: "请选择时间",
          type: "date",
        },
      ],
      cols: [
        { keyName: "cusname", label: "公司名称", minwidth: 150 },
        { prop: "index", label: "操作类别", slot: 'type', minwidth: 150 },
        { prop: "updateTest", label: "操作内容" },
        { prop: "operator", label: "操作人", minwidth: 150 },
        { prop: "updateTime", label: "操作时间", width: 250 },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>
